import React from 'react';
import DirectorySearch from './DirectorySearch';

const SearchCarriers = () => <DirectorySearch type="carrier" title="" />;

export default SearchCarriers;